import { apolloClient } from "@/plugins/vue-apollo.js";

const deleteFacility = (_variables) => {
  let responseFromApi;
  let variables = {
    id: _variables,
  };
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/facility/delete_facility.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/facility/facility_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        store.writeQuery({
          ...query,
          data: data,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { deleteFacility };
